export default class StringReplace {
  filter(value) {
    return value.replaceAll(this.searchValue, this.newValue);
  }
  setOptions(options) {
    this.searchValue = options.searchValue;
    this.newValue = options.newValue;
  }
}